const notifications = {
    en: {
        "notif.title": "Notifications",
        "notif.none": "No notifications",
        "notif.markAllRead": "Mark all read",
        "notif.viewAll": "View all",
    },
    ru: {
        "notif.title": "Уведомления",
        "notif.none": "Нет уведомлений",
        "notif.markAllRead": "Прочитать все",
        "notif.viewAll": "Все",
    },
    geo: {
        "notif.title": "შეტყობინებები",
        "notif.none": "შეტყობინებები არ არის",
        "notif.markAllRead": "ყველას წაკითხვა",
        "notif.viewAll": "ყველა",
    },
};

export default notifications;
